import ServicePageTemplate from '../ServicePageTemplate';

const ASSETS = {
  boilers: "https://images.pexels.com/photos/7859953/pexels-photo-7859953.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

const BoilersService = () => {
  return (
    <ServicePageTemplate
      title="Boilers"
      subtitle="Heating System Experts"
      image={ASSETS.boilers}
      description="BNPH specializes in boiler installation, maintenance, and repair for both residential and commercial applications. Our experienced technicians service steam and hot water boilers, ensuring your heating system operates efficiently and reliably throughout the cold Minnesota winters."
      features={[
        'Expert boiler installation and replacement',
        'Steam and hot water boiler specialists',
        'Comprehensive maintenance programs',
        'Energy efficiency upgrades',
        'Fast repair services',
        '50 years of boiler expertise',
      ]}
      services={[
        'Boiler Installation',
        'Boiler Replacement',
        'Boiler Repair',
        'Steam Boiler Services',
        'Hot Water Boiler Services',
        'Boiler Maintenance',
        'Annual Inspections',
        'System Cleaning',
        'Efficiency Optimization',
        'Controls & Thermostats',
        'Zone Valve Repair',
        'Expansion Tank Service',
      ]}
      relatedServices={[
        { title: 'Water Heaters', link: '/services/water-heaters', description: 'Hot water solutions for your home.' },
        { title: 'Residential', link: '/services/residential', description: 'Complete home plumbing services.' },
        { title: 'Commercial', link: '/services/commercial', description: 'Commercial heating solutions.' },
      ]}
    />
  );
};

export default BoilersService;
